import { openPopup } from './Popup.js';

jQuery(function($){

    const today = new Date();

    if (today.getDay() === 0) {
        $('.zondag-banner').addClass('active');

        $('.wpcf7-submit').on('click', function(e){
        
            e.preventDefault();
            e.stopPropagation();
    
            openPopup('zondag-gesloten');
        });

        $(document).on('click', '.cart__summary-checkout-btn', function(e){
            e.preventDefault();
            e.stopPropagation();
            openPopup('zondag-gesloten');
        });

        if ($('.afrekenen-page').length > 0){
            window.location.href = '/winkelwagen'; 
        }
    
    } 
});


